import { Link } from "react-router-dom";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Service = () => {
  const servicesData = [
    {
      id: 1,
      title: "AI WhatsApp Agents",
      description:
        "Enhance customer engagement with WhatsApp E-store Services for a seamless shopping experience.",
      icon1: <FontAwesomeIcon icon={faWhatsapp} />,
      href: "/whatsapp-estore",
      data_aos_delay: "200ms",
    },
    {
      id: 2,
      title: "RPA",
      description:
        "Streamline operations with RPA and AI to automate tasks, reduce effort, boost efficiency, and drive innovation.",
      icon: "icon-robot-1",
      href: "/RPA-AI",
      data_aos_delay: "00ms",
    },
    {
      id: 3,
      title: "Data & Analytics",
      description:
        "Leverage data and analytics to uncover insights, improve forecasting, optimize operations, and data-driven decisions.",
      icon: "icon-square",
      href: "/Data-Analytics",
      data_aos_delay: "200ms",
    },

    // {
    //   id: 4,
    //   title: "Digital Consulting",
    //   description:
    //     "Digital Consulting empowers businesses with strategic solutions to enhance efficiency, engagement, and growth.",
    //   icon: "icon-server",
    //   href: "/digital-consultancy",
    //   data_aos_delay: "400ms",
    // },
    // {
    //   id: 5,
    //   title: "Web Development",
    //   description:
    //     "We provide custom web development, from landing pages to complex solutions, ensuring business success.",
    //   icon: "icon-coding-1",
    //   href: "/Web-Development",
    //   data_aos_delay: "200ms",
    // },

    // {
    //   id: 5,
    //   title: "Data Engineering",
    //   description:
    //     "Unlock your data’s potential with SiW. Our data engineering speeds up Cloudera deployment, cutting costs and boosting performance.",
    //   icon: "icon-square",
    //   href: "/Data-Engineering",
    //   data_aos_delay: "400ms",
    // },
    // {
    //   id: 6,
    //   title: "Data Science",
    //   description:
    //     "Unlock insights and drive decisions with our data science services. We analyze complex data sets to help your business thrive.",
    //   icon: "icon-12",
    //   href: "/Data-Science",
    //   data_aos_delay: "00ms",
    // },
  ];

  return (
    <section className="service__section p_relative">
      <div className="auto-container">
        <div className="service__data">
          <div className="title__data">
            <div className="sub__title">
              <h4>Better Future</h4>
            </div>
            <div className="title">
              <h2 style={{ color: "white" }}>Explore Our Solutions</h2>
            </div>
          </div>
          <div className="row justify-content-center">
            {servicesData.map((item, id) => (
              <div
                className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated"
                data-wow-delay={item.data_aos_delay}
                data-wow-duration="1500ms"
                key={id}
              >
                <div className="service__block">
                  <div className="service__icon">
                    <i className={item.icon}>{item.icon1}</i>
                    <div className="service__icon__two"></div>
                  </div>
                  <div className="service__text">
                    <h4>
                      <Link to={item.href}>{item.title}</Link>
                    </h4>
                    <p>{item.description}</p>
                  </div>
                  <div className="service__button">
                    <Link to={item.href}>
                      <i className="icon-05"></i>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
